var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.49678C6.605 2.49678 7.099 2.98988 7.099 3.59582C7.099 4.20177 6.605 4.69487 6 4.69487C5.395 4.69487 4.901 4.20177 4.901 3.59582C4.901 2.96751 5.395 2.49678 6 2.49678ZM7.099 9.49771C7.099 10.0589 6.605 10.5073 6 10.5073C5.395 10.5073 4.901 10.0589 4.901 9.49771V6.44764C4.901 5.88643 5.395 5.43807 6 5.43807C6.605 5.43807 7.099 5.88643 7.099 6.44764V9.49771ZM6 12.5C9.32 12.5 12 9.82 12 6.50051C12 3.18 9.32 0.5 6 0.5C2.68 0.5 0 3.18 0 6.50051C0 9.82 2.68 12.5 6 12.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfo);
export default __webpack_public_path__ + "static/media/error-info.c07710a19df450620cf3a615e6c3d9eb.svg";
export { ForwardRef as ReactComponent };